import Layout from "../../../components/Layout";
import Parceiros from "../Dashboard";

export default function ParceirosPage() {
  return Layout(Parceiros, "Portal educacional");
}
